import { render, staticRenderFns } from "./ContactMoneyQuotes.vue?vue&type=template&id=4b90ec82&scoped=true"
import script from "./ContactMoneyQuotes.vue?vue&type=script&lang=js"
export * from "./ContactMoneyQuotes.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyQuotes.vue?vue&type=style&index=0&id=4b90ec82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b90ec82",
  null
  
)

export default component.exports